import React, { useState } from 'react';
import { useSearchParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { AppBar, Tab, Tabs } from '@mui/material';
import Organizations from './Organizations/Organizations';
import Practitioners from './Practitioners/Practitioners';

export const PatientRegistry: React.FC = () => {
  const { t } = useTranslation('PatientRegistry');
  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab') || '';
  const tab = tabFromUrl === 'practitioners' ? 'practitioners' : 'organizations';
  const [activeTab, setActiveTab] = useState<string>(tab);

  return (
    <>
      <AppBar position="static" color="default" sx={{ mt: 2, mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(event, value) => setActiveTab(value)}
          indicatorColor="primary"
          textColor="primary"
          scrollButtons={false}
        >
          <Tab value="organizations" label={t('Organizations:title')} data-pw="organizations_tab" />
          <Tab value="practitioners" label={t('Practitioners:title')} data-pw="practitioners_tab" />
        </Tabs>
      </AppBar>
      {activeTab === 'organizations' && <Organizations />}
      {activeTab === 'practitioners' && <Practitioners />}
    </>
  );
};
